
import LeftMenu from "./leftMenus"

const LeftPanel = () => {

    return(
       <LeftMenu />
    )
} 
export default LeftPanel